<h2 matDialogTitle>View points promotion</h2>

<mat-dialog-content>

  <app-message-panel kind="ERROR" *ngIf="errors">{{ errors }}</app-message-panel>

  <form [formGroup]="fg" class="row">
    <mat-form-field class="col-xs-12" appearance="fill">
      <mat-label>Product</mat-label>
      <mat-select formControlName="productId">
        <mat-option *ngFor="let product of data?.products" [value]="product.id">
          {{ product.name }}
        </mat-option>
        <mat-option [value]="40">
          MagnaClean Professional3 Sense
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="col-xs-12" appearance="fill">
      <mat-label>Name</mat-label>
      <input matInput type="text" formControlName="name" maxlength="255" />
    </mat-form-field>
    <mat-form-field class="col-xs-12" appearance="fill">
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description" matTextareaAutosize
        matAutosizeMinRows="2" matAutosizeMaxRows="5" maxlength="65535"></textarea>
    </mat-form-field>
    <mat-form-field class="col-xs-12" appearance="fill">
      <mat-label>Reference</mat-label>
      <input matInput type="text" formControlName="reference" maxlength="255" />
    </mat-form-field>
    <mat-form-field class="col-xs-12" appearance="fill">
      <mat-label>Points</mat-label>
      <input matInput type="text" formControlName="points" maxlength="65535" />
    </mat-form-field>
    <mat-form-field class="col-xs-6" appearance="fill">
      <mat-label>Start date</mat-label>
      <input matInput [matDatepicker]="startPicker" formControlName="startDate" />
      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="col-xs-6" appearance="fill">
      <mat-label>End date</mat-label>
      <input matInput [matDatepicker]="endPicker" formControlName="endDate" />
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>
  </form>

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button [matDialogClose]="false">Close</button>
  <button mat-button color="warn" (click)="openConfirmDelete()">Delete</button>
</mat-dialog-actions>